import React from "react";
import PropTypes from "prop-types";

export default function Row({ children, className = "" }) {
  return <div className={`row ${className}`.trim()}>{children}</div>;
}

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
